var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 16C3 15.4477 3.44772 15 4.00001 15C4.55229 15 5.00001 15.4477 5.00001 16V19H3V16ZM3 19H21.0001C21.0001 20.1046 20.1047 21 19.0001 21H5C3.89543 21 3 20.1046 3 19ZM20.0001 15C19.4478 15 19.0001 15.4477 19.0001 16V19H21.0001V16C21.0001 15.4477 20.5524 15 20.0001 15Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28036 7.29916L11.3043 3.29855C11.3094 3.28752 11.3205 3.28243 11.3265 3.27649C11.4741 3.12977 11.6651 3.03732 11.8562 3.01018C11.8724 3.01018 11.8887 3.00509 11.9057 3.00509C11.9381 3 11.9714 3 12.0038 3L12.0968 3.00509C12.113 3.00509 12.1292 3.01018 12.1463 3.01018C12.3425 3.03732 12.5284 3.12976 12.676 3.27649C12.6812 3.28158 12.6922 3.29261 12.6982 3.29855L16.7222 7.29916C16.9081 7.48405 17.0002 7.72832 17.0002 7.97258C17.0002 8.21684 16.9073 8.46109 16.7222 8.64599C16.3511 9.01492 15.7445 9.01492 15.3683 8.64599L12.95 6.24163L12.9474 16.0501C12.9474 16.5708 12.5157 17 11.992 17C11.7301 17 11.4895 16.8914 11.3146 16.7235C11.1398 16.5497 11.0365 16.3164 11.0365 16.0501L11.0365 6.24076L8.61816 8.64512C8.24708 9.01405 7.64054 9.01405 7.26435 8.64512C6.90948 8.27025 6.90927 7.66809 7.28036 7.29916Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b588e516869029b3f7377f6b81d7a202.svg";
export { ForwardRef as ReactComponent };